import React from "react";
import UnifiedDocument from "./UnifiedDocument";
import { DOCUMENT_TYPES } from "../config/DocumentConfig";

const UnifiedSalesInvoice = () => {
  return <UnifiedDocument documentType={DOCUMENT_TYPES.SALES_INVOICE} />;
};

export default UnifiedSalesInvoice;
